import React, { useState } from 'react';

import { RadioGroup, VStack } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { Archive } from 'assets/assetsV1/iconComponents';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';
import { Radio } from 'uiToolkitV1/Radio';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const CHILDREN_DELETION_OPTIONS = {
  DELETE: 'DELETE',
  REALIGN: 'REALIGN',
};

export const OKRDeletionModal = ({
  isObjective,
  isOpen,
  onClose,
  okrHasNoChildren = false,
  handleDeleteAllChildOKRs,
  handleRealignChildOKRs,
}) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const [selectedChildrenOption, setSelectedChildrenOption] = useState(CHILDREN_DELETION_OPTIONS.DELETE);

  const BodyComp = okrHasNoChildren ? (
    <ModalBodyNoChildOKRs isObjective={isObjective} />
  ) : (
    <ModalBody
      isObjective={isObjective}
      selectedChildrenOption={selectedChildrenOption}
      setSelectedChildrenOption={setSelectedChildrenOption}
    />
  );

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      title={
        <>
          <Archive style={{ marginRight: '4px' }} />
          <span>Archive {isObjective ? objectivesName : keyResultsName}</span>
        </>
      }
      body={BodyComp}
      cancelText="Cancel"
      onCancel={onClose}
      continueText={selectedChildrenOption === CHILDREN_DELETION_OPTIONS.DELETE ? 'Archive' : 'Re-align'}
      onContinue={
        selectedChildrenOption === CHILDREN_DELETION_OPTIONS.DELETE ? handleDeleteAllChildOKRs : handleRealignChildOKRs
      }
    />
  );
};

const ModalBody = ({ isObjective, selectedChildrenOption, setSelectedChildrenOption }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  return (
    <>
      <TextBodyMedium>
        Archiving this{' '}
        {isObjective
          ? modifyString(objectivesName, StringModifier.SENTENCE_CASE)
          : modifyString(keyResultsName, StringModifier.SENTENCE_CASE)}{' '}
        will also archive all the child {modifyString(moduleName, StringModifier.PLURAL_SENTENCE_CASE)} aligned to it.
        Are you sure you want to continue with archival?
      </TextBodyMedium>
      <RadioGroup onChange={setSelectedChildrenOption} value={selectedChildrenOption}>
        <VStack py={2.5} px={3} alignItems="flex-start">
          <Radio
            isChecked={selectedChildrenOption === CHILDREN_DELETION_OPTIONS.DELETE}
            value={CHILDREN_DELETION_OPTIONS.DELETE}
          >
            <TextBodyMedium>
              I want to archive all child {modifyString(moduleName, StringModifier.PLURAL_SENTENCE_CASE)}{' '}
            </TextBodyMedium>
          </Radio>
          <Radio
            isChecked={selectedChildrenOption === CHILDREN_DELETION_OPTIONS.REALIGN}
            value={CHILDREN_DELETION_OPTIONS.REALIGN}
          >
            <TextBodyMedium>
              I want to re-align child {modifyString(moduleName, StringModifier.PLURAL_SENTENCE_CASE)} to new parent
            </TextBodyMedium>
          </Radio>
        </VStack>
      </RadioGroup>
    </>
  );
};

const ModalBodyNoChildOKRs = ({ isObjective }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  return (
    <TextBodyMedium>
      Are you sure you want to archive this{' '}
      {isObjective
        ? modifyString(objectivesName, StringModifier.SENTENCE_CASE)
        : modifyString(keyResultsName, StringModifier.SENTENCE_CASE)}
      ?
    </TextBodyMedium>
  );
};
